// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1TJM7","subheader":"ReorderModal_subheader__2p1L7","listWrap":"ReorderModal_listWrap__DrOlu"};